import React from "react";

import { NavLink } from "react-router-dom";

import { Typography } from "clearsense-ui/components";

export const LinkText = ({ text, link, state, textSyle = "h4", className }) => (
  <Typography style={textSyle} className={className}>
    <NavLink
      to={`${link || "#"}`}
      alt={`link to ${text}`}
      state={state}
      className="cs-ui-text-primary"
    >
      {text}
    </NavLink>
  </Typography>
);

export const Steward = ({ name, title }) => (
  <div className="cursor-default">
    <Typography style="medium" type="semibold">
      {name ?? "No Name"}
    </Typography>
    <Typography style="h6" className="cs-ui-text-shade-dark">
      {title ?? "No Role"}
    </Typography>
  </div>
);

export const ColumnStyle = ({ text }) => (
  <Typography style="large" className="cursor-default cs-ui-text-shade-dark">
    {text}
  </Typography>
);
